import { initOneTrustFlowWithInjection } from '@ui/one-trust/dist/consent-wiring'

export const injectOneTrustScripts = (SDKKey, segmentKey) => {
  // This function will inject OneTrust and block cookies as well as the user until theu consent
  initOneTrustFlowWithInjection({ sdkKey: SDKKey, segmentWriteKey: segmentKey })
}
